import { useCallback, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useApolloClient } from '@apollo/react-hooks'
import { useHistory } from 'react-router-dom'
import { path, prop } from 'ramda'

import { selectDataSaverOption } from '../actions'
import { getAccountIdFromState } from '../selectors/session'
import { getToken } from '../lib/storage'
import getDeviceInfo from '../lib/device-info'
import useDeviceFingerprint from './use-device-fingerprint'
import CONTENT_ITEM_QUERY from '../../graphql/queries/content-item.gql'
import CONFIG_QUERY from '../../graphql/queries/config.gql'
import ACCOUNT_QUERY from '../../graphql/queries/account.gql'

export default function useInitializeCastSender() {
  const client = useApolloClient()
  const history = useHistory()
  const dispatch = useDispatch()
  const lastPreviewContentIdRef = useRef(null)

  const deviceFingerprint = useDeviceFingerprint()

  const selectedDataSaverOption = useSelector(path(['user', 'account', 'dataSaver']))
  const castSender = useSelector(prop('castSender'))
  const accountId = useSelector(getAccountIdFromState)

  const selectDataSaver = (dataSaverOption) => {
    dispatch(selectDataSaverOption(dataSaverOption, accountId))
  }

  const maybeInitializeCastSender = (url, contentItem, isTrailer) => {
    if (castSender?.isConnected) {
      const deviceInformation = {
        ...getDeviceInfo(),
        uuid: deviceFingerprint,
        platform: 'Web'
      }

      window.castPlayer.loadMedia({
        apolloClient: client,
        selectDataSaverFunction: selectDataSaver,
        selectedDataSaverOption,
        contentItemQuery: {
          query: CONTENT_ITEM_QUERY,
          variables: { id: contentItem.id }
        },
        isVideoExtra: isTrailer,
        deviceUUID: deviceInformation.uuid,
        configQuery: {
          query: CONFIG_QUERY,
          variables: {
            input: { deviceInfo: deviceInformation }
          }
        },
        accountQuery: {
          query: ACCOUNT_QUERY
        },
        contentItemId: contentItem.id,
        app_token: getToken()
      })
    } else {
      history.push(url)
    }
  }

  const castPreviewPageSender = useCallback((contentItem) => {
    if (
      !contentItem?.id ||
      !castSender?.isConnected ||
      lastPreviewContentIdRef.current === contentItem.id
    ) {
      return
    }

    window.castPlayer.loadPreviewPage(contentItem)
    lastPreviewContentIdRef.current = contentItem.id
  }, [castSender])

  return {
    castSender,
    maybeInitializeCastSender,
    castPreviewPageSender
  }
}
